import { z } from "zod";
import { DbCreateInputOmit } from "../helpers";

export const Brand = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  persistentId: z.string(),
  name: z.string(),
  description: z.string(),
});

export type Brand = z.infer<typeof Brand>;
export type CreateBrand = DbCreateInputOmit<Brand>;
